// Masifi: the dashboard's own strings (additions) and improved translations (overrides), merged over upstream
// by withMasifi (shared/i18n/masifi/masifiOverlay.js). "Chatwoot" in these json files is the brand token (replaced at runtime).
import { deepMerge } from 'shared/i18n/masifi/masifiOverlay';
import { installMasifiLinkGuard } from 'shared/helpers/masifi/masifiLinkGuard';

// R1-RD: links de documentación de Chatwoot fuera en marcas ≠ instancia (dashboard + login; no en el widget).
installMasifiLinkGuard(globalThis.window?.globalConfig);

// deep-merge: two files may contribute keys under the same top-level namespace (e.g. INBOX_MGMT).
const load = files =>
  Object.values(files).reduce((acc, json) => deepMerge(acc, json), {});

export default {
  additions: {
    en: load(
      import.meta.glob('./additions/en/*.json', {
        eager: true,
        import: 'default',
      })
    ),
    es: load(
      import.meta.glob('./additions/es/*.json', {
        eager: true,
        import: 'default',
      })
    ),
  },
  overrides: {
    en: load(
      import.meta.glob('./overrides/en/*.json', {
        eager: true,
        import: 'default',
      })
    ),
    es: load(
      import.meta.glob('./overrides/es/*.json', {
        eager: true,
        import: 'default',
      })
    ),
  },
};
